import { connect } from 'react-redux';
import HeroImage from './HeroImage';

const mapStateToProps = ({
  content: { jumbotron: { placeholderSrc, imageSrc }}
}) => ({
  placeholderSrc,
  imageSrc
});

export default connect(mapStateToProps, null)(HeroImage);



// WEBPACK FOOTER //
// ./src/universal/components/HeroImage/index.js